import {ClipboardCopy, Country, Icon} from '@bitstillery/common/components'
import {MithrilComponent} from '@bitstillery/mithril'
import {to_specs} from '@bitstillery/common/lib/specs'
import m from '@bitstillery/mithril'

interface CellProductAttrs {
    product_name: string | null
    number_of_bottles: number | null
    customs_status?: string | null
    gift_box_type?: string | null | undefined
    tax_label?: string | null
    alcohol_percentage?: number | string | null
    volume?: number | string | null
    refill_status?: string | null
    best_before_date?: string | null

    product_category_name?: string | null
    article_code?: string | null
    cbs_code?: string | null
    additional_details?: JSX.Element
    bottle_gtin_code?: string | null | undefined
    country_of_origin?: string | null | undefined

    cases_per_pallet?: number | null
    cases_per_pallet_layer?: number | null
}

export class CellProduct extends MithrilComponent<CellProductAttrs> {
    view(vnode: m.Vnode<CellProductAttrs>) {
        const children: m.ChildArray = []
        children.push(
            <div className='header'>
                {vnode.attrs.product_name}
                <ClipboardCopy text={vnode.attrs.product_name} />
            </div>,
        )
        if (vnode.attrs.alcohol_percentage && vnode.attrs.volume) {
            children.push(
                <span className='details'>
                    {to_specs({
                        bottle_alcohol_percentage: vnode.attrs.alcohol_percentage,
                        bottle_refill_status: vnode.attrs.refill_status,
                        bottle_volume: vnode.attrs.volume,
                        case_customs_status: vnode.attrs.customs_status,
                        case_gift_box_type: vnode.attrs.gift_box_type || '',
                        case_number_of_bottles: vnode.attrs.number_of_bottles,
                        case_tax_label: vnode.attrs.tax_label,
                    })}
                </span>,
            )
        }
        if (vnode.attrs.bottle_gtin_code) {
            children.push(<span class='details'>{vnode.attrs.bottle_gtin_code}</span>)
        }
        if (vnode.attrs.article_code) {
            children.push(<span class='details'>{vnode.attrs.article_code}</span>)
        }
        if (vnode.attrs.cbs_code) {
            children.push(<span class='details'>CBS: {vnode.attrs.cbs_code}</span>)
        }
        if (vnode.attrs.country_of_origin || vnode.attrs.product_category_name) {
            children.push(
                <div className='details'>
                    {vnode.attrs.country_of_origin && <Country country_code={vnode.attrs.country_of_origin} size='xs' />}{' '}
                    {vnode.attrs.product_category_name}
                </div>,
            )
        }
        if (vnode.attrs.cases_per_pallet || vnode.attrs.cases_per_pallet_layer) {
            children.push(
                <div className='dimension-info'>
                    <Icon name='cpp' size='xs' />
                    <div className='stat'>
                        {vnode.attrs.cases_per_pallet && <span>{`${vnode.attrs.cases_per_pallet} cpp`}</span>}
                        {vnode.attrs.cases_per_pallet_layer && <span>{`${vnode.attrs.cases_per_pallet_layer} cpl`}</span>}
                    </div>
                </div>,
            )
        }

        if (vnode.attrs.additional_details) {
            children.push(vnode.attrs.additional_details)
        }

        return <div className='c-cell-product td-group'>{children}</div>
    }
}
